// @ts-check
import {Modal, TextField, Toggle} from '@/components/atoms'
import {useComboSetupSection} from '@/hooks/productCombo/useComboSetupSection'
import {MODAL_TYPE} from '@/utils/constants/globalStyle'
import {Font} from 'pepsico-ds'

export const ComboSetupSection = () => {
  const {
    name,
    active,
    comboLimitInput,
    comboLimitError,
    hasComboLimitValue,
    errors,
    showInvalidStatusModal,
    handleComboLimitChange,
    updateActiveStatus,
    handleCloseModal,
    updateProductCombo,
  } = useComboSetupSection()

  return (
    <div className="flex flex-col gap-6 rounded-lg bg-gray-850 p-6">
      <Font variant="bold">Combo Setup</Font>
      <div className="flex gap-6">
        <TextField
          label="Combo Name*"
          value={name}
          updateValue={value => updateProductCombo({name: value})}
          error={name ? errors.name : undefined}
          uiSchema={{placeholder: 'Product Combo Name', className: 'w-[350px]'}}
        />
        <TextField
          label="Combo Limit*"
          value={comboLimitInput}
          updateValue={handleComboLimitChange}
          error={comboLimitError || (!comboLimitInput && hasComboLimitValue ? errors.comboLimit : undefined)}
          uiSchema={{placeholder: 'Combo Limit', className: 'w-[350px]'}}
          type="text"
        />
      </div>
      <div className="h-px bg-gray-600" />
      <Font variant="bold">Availablity</Font>
      <Toggle
        value={active}
        updateValue={value => updateActiveStatus(value)}
        uiSchema={{size: 'small', label: 'Active'}}
      />
      <Modal
        type={MODAL_TYPE.SMALL}
        showModal={showInvalidStatusModal}
        title="This combo product has one or more inactive products associated to it."
        primaryButtonText="Ok"
        classNameWrapper="min-h-80"
        onClickPrimaryButton={handleCloseModal}
        hideCloseButton={true}
      />
    </div>
  )
}
